import type { SwitchProps } from 'uikit';
import { Switch } from 'uikit';

import type React from 'react';
import { useCallback } from 'react';
import type { Control } from 'react-hook-form';
import { useController } from 'react-hook-form';

type TControlledSwitch = Omit<SwitchProps, 'onChange' | 'checked'> & {
    control: Control;
    name: string;
};

export const ControlledSwitch = (props: TControlledSwitch) => {
    const { control, name, ...rest } = props;

    const { field } = useController({
        name,
        control,
    });

    const onChange = useCallback(
        ({ checked }) => {
            field.onChange(checked);
        },
        [field],
    );

    return <Switch {...rest} checked={field.value} onChange={onChange} />;
};

ControlledSwitch.displayName = 'ControlledSwitch';
